import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'

export const TickBoldIcon: FunctionComponent<IconProps> = ({
  fill,
  customColour,
  width = 20,
  height = 20,
  ...rest
}) => {
  const fillColour = customColour ? customColour : '#01892E'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M.5 12.4l2-2.1 3.6 3.5L17.4 2.5l2.1 2.1L6.1 18 .5 12.4z"
        fill={fillColour}
        fillRule="evenodd"
      />
    </Icon>
  )
}
